import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useClientService, ClientService } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<ClientService>
      useData={useClientService}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

